import { useState } from "react";
import type { CallbackEvent } from "@shopify/polaris-types";
import { useOtpTestSend } from "../../hooks/useOtpTestSend";

export function OtpTestSection({ isDirty }: { isDirty: boolean }) {
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const {
    sending,
    verifying,
    error,
    requestId,
    channelUsed,
    actualCostUsd,
    verified,
    sendTest,
    verifyTest,
  } = useOtpTestSend();

  return (
    <s-section heading="Verifica que funciona — envía una prueba real">
      <s-stack direction="block" gap="small-200">
        <s-text color="subdued">
          Envía un OTP real a tu propio teléfono con el canal y el mensaje
          guardados, luego introduce el código para confirmar que todo funciona.
        </s-text>

        {isDirty && (
          <s-banner tone="warning">
            Guarda primero los cambios — la prueba usa la configuración
            guardada.
          </s-banner>
        )}

        <s-box inlineSize="auto" maxInlineSize="320px">
          <s-text-field
            label="Número de teléfono de prueba"
            placeholder="+573001234567"
            value={phone}
            onInput={(e: CallbackEvent<"s-text-field">) =>
              setPhone(e.currentTarget.value)
            }
          />
        </s-box>
        <s-text color="subdued">
          Usa el formato internacional completo, incluido el código de país
          (ejemplo: +57 5551234).
        </s-text>

        <s-stack direction="inline" gap="small-200" alignItems="center">
          <s-button
            disabled={isDirty || sending || !phone}
            onClick={() => sendTest(phone)}
          >
            Enviar prueba
          </s-button>
          {sending && <s-spinner accessibility-label="Enviando…" />}
        </s-stack>

        {error && <s-banner tone="critical">{error}</s-banner>}

        {requestId && !verified && (
          <s-banner tone="success">
            Enviado a través de {channelUsed}. Costo: $
            {actualCostUsd?.toFixed(4)}.
          </s-banner>
        )}

        {requestId && !verified && (
          <s-stack direction="block" gap="small-200">
            <s-text>
              <strong>Introduce el código que recibiste</strong>
            </s-text>
            <s-box inlineSize="auto" maxInlineSize="160px">
              <s-text-field
                label="Código de 6 dígitos"
                value={code}
                onInput={(e: CallbackEvent<"s-text-field">) =>
                  setCode(e.currentTarget.value)
                }
              />
            </s-box>
            <s-stack direction="inline" gap="small-200">
              <s-button
                variant="primary"
                disabled={verifying || !code}
                onClick={() => verifyTest(code)}
              >
                Verificar
              </s-button>
              <s-button onClick={() => sendTest(phone)}>
                Reenviar código
              </s-button>
            </s-stack>
          </s-stack>
        )}

        {verified && (
          <s-banner tone="success">El OTP funciona. Todo está listo.</s-banner>
        )}
      </s-stack>
    </s-section>
  );
}
